import * as ngRouter from '@uirouter/angularjs';

import { getCurrentUsername, getOwnerUsername } from '@mode/shared/util-js';
// eslint-disable-next-line @nx/enforce-module-boundaries
import {
  AccountResource,
  DeprecatedApiService,
  OrganizationFeatureResource,
  OrganizationResource,
  ScimTokenResource,
} from '@mode/legacy/data-access-model-js';

import { MembersComponent } from './members.component';
import { uiRouterComponent } from './util';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { OrgSettingsService } from '@mode/workspace-settings/shell-angularjs';

export const MembersRoutesConfig = [
  '$stateProvider',
  ($stateProvider: ngRouter.StateProvider) => {
    $stateProvider.state('org-settings.members-panel', {
      url: `/members?filter`,
      ...uiRouterComponent(MembersComponent),
      resolve: {
        currentUser: MemberPanelResolvers.currentUser,
        organization: MemberPanelResolvers.organization,
        orgFeatures: MemberPanelResolvers.orgFeatures,
        orgIsManagedByScim: MemberPanelResolvers.orgIsManagedByScim,
        memberFilter: MemberPanelResolvers.memberFilter,
      },
    } as ngRouter._Ng1StateDeclaration);
  },
];

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace MemberPanelResolvers {
  export const currentUser = [
    'AccountModel',
    async function (AccountModel: any): Promise<AccountResource> {
      return AccountModel.find({
        username: getCurrentUsername(window.document),
        useEntryPath: true,
      }).then((model: any) => model._resource);
    },
  ];

  export const organization = [
    'AccountModel',
    async function (AccountModel: any): Promise<OrganizationResource> {
      const orgUsername = getOwnerUsername(window.document);

      return AccountModel.find({
        username: orgUsername,
        useEntryPath: true,
        includes: ['organization_features'],
      }).then((model: any) => model._resource);
    },
  ];

  export const orgIsManagedByScim = [
    'organization',
    'OrgSettingsService',
    async function (org: OrganizationResource, oss: OrgSettingsService): Promise<boolean> {
      return oss.getScimToken(org).then((scimToken: ScimTokenResource | null) => !!scimToken?.only_scim_provision);
    },
  ];

  export const orgFeatures = [
    'organization',
    'ApiService',
    async function (
      organization: OrganizationResource,
      ApiService: DeprecatedApiService
    ): Promise<OrganizationFeatureResource> {
      return ApiService.getResource<OrganizationFeatureResource>(organization, 'organization_features');
    },
  ];

  export const memberFilter = [
    '$stateParams',
    function ($stateParams: ngRouter.StateParams) {
      return $stateParams['filter'];
    },
  ];
}
